export default {
    isTablet() {
      const w = window.innerWidth;
      // Only treat it as a tablet on an actual touch device. Otherwise a desktop
      // browser with a narrowed window (768â€“1199px) was misclassified as a tablet,
      // which made el-tooltip skip its hover listeners so tooltips never showed.
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

      return isTouchDevice && w < 1200 && w >= 768;
    }
  };
  